import { useState } from 'react';
import { CorporationService } from '../../services/corporation/corporationService';

/*-------------------------------------------------------------------------------------------
* EN: Hook to manage providing corporations fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación de empresas impartidoras.
-------------------------------------------------------------------------------------------*/

const useProvidingCorporations = (initialFilters = {}) => {

    const [data, setData] = useState<any[]>([]);
    const filters = {
        limit: 200,
        filter_filters: { ...initialFilters }
    };

    const fetchProvidingCorporations = async (f: any) => {
        const newFilters = { ...filters, filter_filters: { ...filters.filter_filters, ...f } };
        try {
            const response = await (new CorporationService()).listProvidingCorporations(newFilters);
            const fetchedData = response.getResponseData()?.data;

            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map((data: { id: string; name: string; }) => ({
                    value: data.id,
                    label: data.name,
                }));
                setData(mappedData);
                return mappedData;
            }
        } catch (error) {
            console.log('Error fetching providing corporations:', error);
        }
    };

    const getProvidingCorporationsList = () => {
        return data;
    };

    return { fetchProvidingCorporations, getProvidingCorporationsList };
}

export default useProvidingCorporations;